import OrderList from "./OrderList";
import MonthlySales from "./MonthlySales";
import Vendor from "./Vendor";
import Payment from "./Payment";
import { Tabs } from "antd";

const items = [
  {
    key: "1",
    label: "Orders List",
    children: <OrderList />,
  },
  {
    key: "2",
    label: "ยอดขายรายเดือนที่ปิดแล้ว",
    children: <MonthlySales />,
  },
  {
    key: "3",
    label: "Vendor Management",
    children: <Vendor />,
  },
  {
    key: "4",
    label: "ระบบทำจ่าย",
    children: <Payment />,
  },
];

function HytextsReport() {
  return <Tabs defaultActiveKey="1" items={items} />;
}

export default HytextsReport;
